module.exports = __webpack_public_path__ + "img/04.3df16f33.png";